import { useState } from 'react';
import './BulkActionsMenu.css';

function BulkActionsMenu({ selectedCount, categories, onAction, onClearSelection }) {
  const [action, setAction] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const handleActionChange = (e) => {
    const selectedAction = e.target.value;
    setAction(selectedAction);

    if (selectedAction === 'assign-category') {
      setShowCategoryModal(true);
    }
  };

  const handleApply = async () => {
    if (!action) return;

    if (action === 'assign-category' && !categoryId) {
      alert('Please select a category');
      return;
    }

    // Show confirmation for destructive actions
    if (action === 'delete' || action === 'archive') {
      const actionLabel = action === 'delete' ? 'delete' : 'archive';
      if (!window.confirm(`Are you sure you want to ${actionLabel} ${selectedCount} product(s)?`)) {
        return;
      }
    }

    try {
      await onAction(action, categoryId);
      setAction('');
      setCategoryId('');
      setShowCategoryModal(false);
    } catch (error) {
      console.error('Bulk action failed:', error);
    }
  };

  const handleCategoryModalClose = () => {
    setShowCategoryModal(false);
    setAction('');
    setCategoryId('');
  };

  const handleCategoryAssign = () => {
    if (!categoryId) {
      alert('Please select a category');
      return;
    }
    setShowCategoryModal(false);
    handleApply();
  };

  return (
    <>
      <div className="bulk-actions-menu">
        <div className="bulk-actions-info">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="selection-count">
            {selectedCount} {selectedCount === 1 ? 'product' : 'products'} selected
          </span>
        </div>

        <div className="bulk-actions-controls">
          <select
            className="bulk-action-select"
            value={action}
            onChange={handleActionChange}
          >
            <option value="">Choose an action...</option>
            <optgroup label="Status">
              <option value="publish">Publish (Set to Active)</option>
              <option value="draft">Set to Draft</option>
              <option value="archive">Archive</option>
            </optgroup>
            <optgroup label="Featured">
              <option value="feature">Mark as Featured</option>
              <option value="unfeature">Remove from Featured</option>
            </optgroup>
            <optgroup label="Category">
              <option value="assign-category">Assign to Category...</option>
            </optgroup>
            <optgroup label="Danger Zone">
              <option value="delete">Delete</option>
            </optgroup>
          </select>

          <button
            className="btn btn-primary btn-sm"
            onClick={handleApply}
            disabled={!action || (action === 'assign-category' && !categoryId)}
          >
            Apply
          </button>

          <button
            className="btn btn-secondary btn-sm"
            onClick={onClearSelection}
            title="Clear selection"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Category Assignment Modal */}
      {showCategoryModal && (
        <div className="modal-overlay" onClick={handleCategoryModalClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Assign to Category</h3>
              <button
                className="modal-close"
                onClick={handleCategoryModalClose}
                aria-label="Close"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="modal-body">
              <p className="modal-text">
                Select a category for {selectedCount} selected {selectedCount === 1 ? 'product' : 'products'}
              </p>

              <div className="form-group">
                <label htmlFor="category-select" className="form-label">Category</label>
                <select
                  id="category-select"
                  className="form-select"
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                >
                  <option value="">Select a category...</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={handleCategoryModalClose}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleCategoryAssign}
                disabled={!categoryId}
              >
                Assign Category
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BulkActionsMenu;
